<template>
  <div class="flex flex-col justify-between">
    <div :class="{ 'flex items-start space-x-12': sticky }">
      <div
        class="bg-static-default-low border-static-default-low rounded-lg shrink-0"
        :class="sticky ? 'w-32 lg:w-[88px] lg:p-8 lg:border' : 'p-16 border'"
      >
        <RevIllustration
          v-if="product.images?.[0]"
          :alt="product.title"
          class="w-full"
          :height="sticky ? 88 : 506"
          :sizes="sticky ? '88px' : '506px'"
          :src="product.images[0].url"
          :width="sticky ? 88 : 506"
        />
      </div>
      <div class="min-w-0" :class="{ 'mt-12': !sticky }">
        <span
          class="text-static-default-hi"
          :class="sticky ? 'body-1-bold line-clamp-2' : 'heading-2'"
          >{{ product.title }}</span
        >
        <div v-if="product.price" data-spec="price-information">
          <div class="text-static-default-low caption">
            {{ i18n(translations.startingFrom) }}
          </div>
          <ProductPrice
            :new-price="sticky ? undefined : product.priceWhenNew"
            :price="product.price"
          />
        </div>
      </div>
    </div>
    <RevButton
      class="w-full"
      :class="sticky ? 'mt-8 lg:mt-16' : 'mt-24'"
      :size="sticky ? 'small' : 'medium'"
      :to="productPageUrl"
      variant="primary"
    >
      {{ i18n(translations.seeOptions) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ModelComparisonCompareProduct } from '@backmarket/http-api/src/api-specs-model-comparison/models/compare-models'
import ProductPrice from '@backmarket/nuxt-layer-recommendation/ProductPrice.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

import translations from './ModelsComparisonProductCard.translations'

const { product, sticky = false } = defineProps<{
  product: ModelComparisonCompareProduct
  sticky?: boolean
}>()
const i18n = useI18n()

const productPageUrl = computed(() => ({
  name: PRODUCT_ROUTES.MASTER_PRODUCT_PAGE,
  params: {
    locale: toBcp47Locale(i18n.currentLocale),
    slug: product.slug,
  },
}))
</script>
